import React, { useRef, useEffect, useState } from "react";
import api from "../../services/api";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { Form, Modal, Button, Grid, Image, Loader, Dimmer, Segment, Divider, Input } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import ImageZoom from "../../components/ImageZoom";
import ModalYesNo from "../../components/ModalYesNo";

import ImagemRepository from "../../Repositories/ImagesRepository";
import PaymentsRepository from "../../Repositories/PaymentsRepository"

import { IImagem } from "../../interfaces";
import { GetUser } from "../../services/auth";
import CustomLoader from "../../components/CustomLoader";


interface State {
    images: IImagem[];
    observacao: string;
    numeroComprovante: string;
    apiErrors: IAliancaErrors;
}

interface Props {
    entradaId: string;
    onSuccess: () => void;
}

const initialState: State = {
    images: [],
    observacao: "",
    numeroComprovante: "",
    apiErrors: { errors: [] }
}

const DetalharEntrada: React.FC<Props> = ({ entradaId, onSuccess }) => {

    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [preview, setPreview] = useState<string[]>([]);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const { role } = GetUser();

    const load = async () => {
        setLoading(true);

        try {

            const [observacao, images] = await Promise.all([
                PaymentsRepository.GetById(entradaId),
                ImagemRepository.GetByReferenceId(entradaId)

            ]);

            setState(state => ({
                ...state,
                ...observacao,
                images
            }));

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }

    useEffect(() => {
        if (selectedFiles.length > 0) {
            let images: string[] = [];

            for (const file of selectedFiles) {
                images.push(URL.createObjectURL(file));
            }

            setPreview(preview => preview.concat(images));

            return () => {
                for (const image of images) { URL.revokeObjectURL(image) }
                setPreview([]);
            }
        }
    }, [selectedFiles])


    const onRemovePreview = (imageUrl: string, index: number) => {
        const images = preview.filter(x => x !== imageUrl);

        selectedFiles.splice(index, 1);

        URL.revokeObjectURL(imageUrl);
        setPreview(images);
    }

    const onRemove = async (id: string) => {
        await ImagemRepository.DeleteById(id);
        load();
    }

    const handleOpen = () => {
        load();

        setOpen(true);
    }

    const handleClose = () => {
        setState({ ...state, apiErrors: { errors: [] } });
        setOpen(false);
        setSelectedFiles([]);
        setPreview([]);
    }

    const editarContent = (
        <Modal.Content>
            {loading &&
                <Dimmer active inverted>
                    <CustomLoader />
                </Dimmer>}
            {!loading &&
                <>
                    <Form>
                        <Grid.Column>
                            <Form.Field>
                                <label>Observação</label>
                                <Input
                                    fluid
                                    placeholder="Observação ..."
                                    name="observacao"
                                    value={state.observacao}
                                    readonly
                                />
                            </Form.Field>
                        </Grid.Column>
                        {
                            state.images.length > 0 &&
                            <>
                                <Divider />
                                <Segment placeholder>
                                    <Grid columns={1} stackable>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Grid columns={4} doubling textAlign="center">
                                                    {state.images.length > 0 &&
                                                        state.images.map((x, index) =>
                                                            <Grid.Column key={`image-${index}`}>
                                                                <Image
                                                                    fluid
                                                                    label={<ImageZoom imagePath={`${api.defaults.baseURL}/images/${x.arquivo}`} />}
                                                                    src={`${api.defaults.baseURL}/images/${x.arquivo}`}
                                                                />
                                                                <ModalYesNo
                                                                    trigger={<Button icon="trash" color="red" attached="bottom" disabled={(role !== "Admin" && role !== "Operador")} />}
                                                                    header="Apagar"
                                                                    content="Deseja realmente apagar esta foto?"
                                                                    onSuccess={() => onRemove(x.id || "")}
                                                                />
                                                            </Grid.Column>
                                                        )}
                                                </Grid>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Segment>
                            </>
                        }
                        {
                            preview.length > 0 &&
                            <>
                                <Divider />
                                <Segment placeholder>
                                    <Grid columns={1} stackable>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Grid columns={4} doubling textAlign="center">
                                                    {preview.length > 0 &&
                                                        preview.map((x, index) =>
                                                            <Grid.Column key={`image-${index}`}>
                                                                <Image
                                                                    fluid
                                                                    label={<ImageZoom imagePath={x} />}
                                                                    src={x}
                                                                />
                                                                <ModalYesNo
                                                                    trigger={<Button icon="trash" color="red" attached="bottom" />}
                                                                    header="Apagar"
                                                                    content="Deseja realmente apagar esta foto?"
                                                                    onSuccess={() => onRemovePreview(x, index)}
                                                                />
                                                            </Grid.Column>
                                                        )}
                                                </Grid>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Segment>
                            </>
                        }
                    </Form>
                </>}
        </Modal.Content >
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title={"Comprovante " + state.numeroComprovante}
            content={editarContent}
            trigger={{
                icon: "info",
                color: "blue"
            }}
        />
    );
};

export default DetalharEntrada;
